import React from "react";

function TextOnlyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="211"
      height="124"
      fill="none"
      viewBox="0 0 211 124"
    >
      <path stroke="#000" d="M0.5 0.5H210.5V102.5H0.5z"></path>
      <path stroke="#000" strokeWidth="4" d="M23 25L184 25"></path>
      <path stroke="#000" strokeWidth="4" d="M23 33L152 33"></path>
      <path stroke="#000" d="M23.003 45.5L184.003 46.5"></path>
      <path stroke="#000" d="M23 50.5L184 50.5"></path>
      <path stroke="#000" d="M23 54.5L184 54.5"></path>
      <path stroke="#000" d="M23 58.5L154 58.5"></path>
      <path stroke="#000" d="M23 62.5L141 62.5"></path>
      <path stroke="#000" d="M23 66.5L108 66.5"></path>
    </svg>
  );
}

export default TextOnlyIcon;
